/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'house': {
    width: 18,
    height: 18,
    viewBox: '0 0 18 18',
    data: '<path pid="0" d="M17.82 8.285L9.896.362c-.482-.482-1.324-.483-1.808 0L.11 8.34a.375.375 0 00.265.64H1.5v8.618c0 .207.167.375.374.375H6.37a.375.375 0 00.375-.375v-6.37h4.496v6.37c0 .207.168.375.375.375h4.496a.375.375 0 00.375-.375V8.98h1.131A.373.373 0 0018 8.605a.377.377 0 00-.18-.32" _fill="#231F20" fill-rule="evenodd"/>'
  }
})
